/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Mon, 24 Nov 2025 17:04:18 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import { BankAccountType } from '@/types/bankAccountType';

const valuesOfBankAccountType: readonly string[] = ['CHECKING', 'SAVINGS', ''];

export const isBankAccountType = (value: unknown): value is BankAccountType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfBankAccountType.includes(value);
};

export const isBankAccountTypeOrNull = (value: unknown): value is BankAccountType | null => {
  return value === null || isBankAccountType(value);
};

export const isArrayOfBankAccountType = (value: unknown): value is BankAccountType[] => {
  return Array.isArray(value) && value.every(isBankAccountType);
};

export const isArrayOfBankAccountTypeOrNull = (
  value: unknown,
): value is BankAccountType[] | null => {
  return value === null || isArrayOfBankAccountType(value);
};
